import { PaymentMethodEnum, Payment } from "../../../"

export class InitPaymentResponse {
    paymentModes: PaymentMethodEnum[]
    boReference: string
    payments: Payment[]
    paymentOptions: {
        data: any,
        method: PaymentMethodEnum,
    }[]
    paymentCondition: number
    cancelationDate: string
    totalPrice: number

    constructor(
        paymentModes: PaymentMethodEnum[],
        boReference: string,
        payments: Payment[],
        paymentOptions: {
            data: any,
            method: PaymentMethodEnum,
        }[],
        paymentCondition: number,
        cancelationDate: string,
        totalPrice: number
    ) {
        this.paymentModes = paymentModes
        this.boReference = boReference
        this.payments = payments
        this.paymentOptions = paymentOptions
        this.paymentCondition = paymentCondition
        this.cancelationDate = cancelationDate
        this.totalPrice = totalPrice
    }
}